import { FC, useMemo } from "react"
import { DLMROI } from "../../_models"

import { DetailCard } from "../../../../../components/layout"
import { sortBy, filter, sumBy } from 'lodash';

type Props = {
  details : DLMROI
  cardTitle?: string
}

const ROITargets: FC<Props> = ({details, cardTitle = "Target Details"}) => {

  
  const { targets, targetQty } = useMemo(() =>{
    if (! details) return { targets: [], targetQty : 0} ;

    // @ts-ignore
    const targets = sortBy(filter(details.roiDetails, (obj) => (! obj?.deleted)), (o) => parseInt(`${o.targetDetail.itemNo}`))
    // @ts-ignore
    const targetQty = sumBy(targets, o => (o.targetLabels.length));
    return { targets, targetQty };

  }, [details])

  if (! (details && details?.roiDetails && details?.roiDetails.length > 0)) {
    return null;
  }

  return (
  <DetailCard cardTitle={cardTitle}>
    <div className='table-responsive min-h-80px mh-375px'>
      <table
        className='table align-middle table-row-bordered table-row-gray-300 fs-7 gy-2 dataTable'
      >
        <thead>
          <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
            <th className="p-2">No</th>
            <th className="p-2 text-center">Selected</th>
            <th className="p-2 text-center">Quantity</th>            
            <th className="p-2 text-center">Series</th>            
            <th className="p-2">Dimensions</th>
            <th className="p-2">Type</th>      
            <th className="p-2">Remarks</th>      
          </tr>          
        </thead>
        <tbody className='text-gray-800 align-middle fs-7'>
        { targets.map((target: any, idx: number) => (
          <tr key={`targetRow-${idx}`}>
            <td className="p-2 align-top">
              <div>
                {target.targetDetail?.itemNo ? target.targetDetail?.itemNo : idx + 1 }
              </div>
            </td>
            <td className="p-2 align-top fw-bold mw-250px">
              <div>
                {
                  sortBy(target.targetLabels, 'serialNumber').map((o:any) => o.serialNumber.toString().padStart(6,'0')).join(', ') 
                }
              </div>
            </td>
            <td className="p-2 align-top text-center">
              <div>
                {`${target.targetLabels.length} / ${target.targetDetail.quantity}`}
              </div>
            </td>            
            <td className="p-2 align-top text-center">
              <div>
                { (target.targetDetail.labelFrom === target.targetDetail.labelTo) ? (
                    `${target.targetDetail.labelTo}`
                ) : (
                    `${target.targetDetail.labelFrom} - ${target.targetDetail.labelTo}`
                )}                
              </div>
            </td>            
            <td className="p-2 align-top">
              <div>
                {target.targetDetail.size}
              </div>
            </td>
            <td className="p-2 align-top">
              <div>
                {target.targetDetail.type}
              </div>
            </td>    
            <td className="p-2 align-top">
              <div>
                {target.targetDetail.remarks}
              </div>
            </td>                       
          </tr>          
        ))
        }
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={2} className="p-2 align-top text-muted fw-bold text-end">Total selected labels:</td>
            <td className="p-2 align-top text-center fw-bold">{targetQty}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </DetailCard>
  )
}

export {ROITargets}